/**
 * Flags is our TS modeling of the flags provided by Launch Darkly.
 * our hooks use this to know what is available.
 */
export type Flags = {
  // When a flag is added here it should reference its removal ticket.
  // ex. "docupload-preview": false; // removal HC-123
  "doc-upload-redesign-use-legacy-message-keys": boolean; // removal HC-154
  "font-size": "default" | "control" | "14px" | "16px"; // removal HC-208
  "doc-upload-may24": "default" | "control" | "checkbox-requirements" | "doc-type-icons";
  "include-cvec-field-france-student":
    | "default"
    | "control"
    | "labeled-optional"
    | "not-labeled-optional"; // removal HC-736
  "collect-info-step-email-first":
    | "default"
    | "control"
    | "message-dimmed-fields"
    | "no-message-dimmed-fields"; // removal HC-825
  "docUpload-assertion-checklist": "default" | "control" | "checklist"; // removal: HC-893
  "doc-upload-considerations": "default" | "control" | "add-doc-considerations";
};

/**
 * These are flag defaults they are passed into the LD flag provider and
 * populate the provider before LD's responses come back.
 */
export const flagDefaults: Flags = {
  "doc-upload-redesign-use-legacy-message-keys": false,
  "font-size": "default",
  "doc-upload-may24": "default",
  "include-cvec-field-france-student": "default",
  "collect-info-step-email-first": "default",
  "docUpload-assertion-checklist": "default",
  "doc-upload-considerations": "default",
};

export type FlagNames = keyof Flags;
